export enum ERROR_CODES {
  PERMISSION_DENIED = 'permission_denied',
  VISITANT_PERMISSION_DENIED = 'visitant_permission_denied',
  DOES_NOT_EXIST = 'does_not_exist',
}
